/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import SEOMetaTag, { type MetaTagContent } from '../../ContentBlocks/SEOMetaTag';
import { getCartridgeType } from '@/utils/getCartridgeType';

export type HeadTemplateProps = {
  content?: Array<{ '@type': string } & MetaTagContent>;
};

export const HeadTemplate = ({ content }: HeadTemplateProps) => {
  const renderContentBlocks = (contentType: string, contentItem: MetaTagContent, i: number) => {
    const key = `${contentType}-${i}`;

    switch (contentType) {
      case 'SEOMetaTag':
        return <SEOMetaTag contentItem={contentItem} key={key} />;
    }
  };

  return (
    <>
      {content?.map((contentItem, i) => {
        const contentType = getCartridgeType(contentItem['@type']);

        return renderContentBlocks(contentType, contentItem, i);
      })}
    </>
  );
};
